import React, { useEffect, useRef, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { CheckCircle, AlertCircle, Loader2 } from "lucide-react";
import { authAPI } from "../../services/api";

const VerifyEmail = () => {
  const { token } = useParams();
  const navigate = useNavigate();
  const firedRef = useRef(false);
  const [state, setState] = useState("verifying"); // verifying | success | error
  const [message, setMessage] = useState("");

  useEffect(() => {
    if (firedRef.current) return;
    firedRef.current = true;

    (async () => {
      try {
        const res = await authAPI.verifyEmail(token);
        setState("success");
        setMessage(res.data?.message || "Email verified.");
        setTimeout(() => navigate("/dashboard", { replace: true }), 2500);
      } catch (err) {
        setState("error");
        setMessage(
          err.response?.data?.detail ||
            "This verification link is invalid or has expired.",
        );
      }
    })();
  }, [token, navigate]);

  return (
    <div className="min-h-screen bg-cyber-50 cyber-grid-bg flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        <div className="text-center mb-6">
          <a
            href="https://shinobi.milot.io/"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Go to shinobi.milot.io"
            className="inline-block transition-transform hover:scale-105"
          >
            <img
              src="/logos/wasabi-shinobi-mark-256.png"
              alt="Wasabi Shinobi"
              className="w-20 h-20 mx-auto"
            />
          </a>
        </div>
        <div className="cyber-card rounded-lg p-8 shadow-2xl text-center">
          {state === "verifying" && (
          <>
            <Loader2 className="w-12 h-12 text-shinobi-purple animate-spin mx-auto mb-4" />
            <h2 className="text-xl font-bold text-slate-900 mb-2">Verifying…</h2>
            <p className="text-sm text-gray-500">Just a moment.</p>
          </>
        )}

        {state === "success" && (
          <>
            <div className="w-16 h-16 rounded-full bg-neon-green/10 border border-neon-green/40 flex items-center justify-center mx-auto mb-4">
              <CheckCircle className="w-8 h-8 text-neon-green" />
            </div>
            <h2 className="text-xl font-bold text-slate-900 mb-2">Email verified</h2>
            <p className="text-sm text-slate-500 mb-6">{message}</p>
            <p className="text-xs text-gray-600">Taking you to the dashboard…</p>
          </>
        )}

        {state === "error" && (
          <>
            <div className="w-16 h-16 rounded-full bg-red-50 border border-red-200 flex items-center justify-center mx-auto mb-4">
              <AlertCircle className="w-8 h-8 text-red-600" />
            </div>
            <h2 className="text-xl font-bold text-slate-900 mb-2">Verification failed</h2>
            <p className="text-sm text-slate-500 mb-6">{message}</p>
            <Link
              to="/dashboard"
              className="btn-cyber inline-block px-6 py-2 rounded font-semibold text-sm uppercase tracking-wider"
            >
              Go to dashboard
            </Link>
          </>
        )}
        </div>
      </div>
    </div>
  );
};

export default VerifyEmail;
